import type { MouseEvent } from 'react'

import type { MeInformation } from '@api'
import { useUnit } from 'effector-react'

import { $creatorId } from '@/models/creators.ts'

import { NavItem } from './nav-item.tsx'
import type { NavSingleButtonProps } from './nav-single-button.tsx'

interface NavSectionProps {
  account: MeInformation | null
  items: NavSingleButtonProps[]
  onClick: (
    event: MouseEvent<HTMLAnchorElement>,
    item: NavSingleButtonProps,
  ) => void
}

export const NavSection = ({ items, onClick }: NavSectionProps) => {
  const creatorId = useUnit($creatorId)

  return (
    <div className="flex flex-col gap-2">
      {items.map((item: NavSingleButtonProps) => (
        <NavItem
          key={
            item.title +
            '_' +
            item.href.replace(':creatorId', creatorId?.toString() ?? '')
          }
          item={item}
          onClick={(event) => onClick(event, item)}
        />
      ))}
    </div>
  )
}
